import PieChartComponent from '../utils/PieChartComponent';
import { getTotalsGraph } from '../DiscipleshipCharts';

export const DiscipleshipInactiveGroupsCharts = ({
  closedGroupsByCategoryPieChartData,
  closedGroupsByGroupTypePieChartData,
  selectedCategoryForOpenGroups,
  closedGroupsByActivityName,
}) => {
  const closedInGeneration = closedGroupsByActivityName[selectedCategoryForOpenGroups]?.length || 0;

  return (
    <>
      <div className="totalLabels">
        Total de grupos inactivos:{' '}
        {getTotalsGraph(closedGroupsByCategoryPieChartData) ||
          getTotalsGraph(closedGroupsByGroupTypePieChartData)}
      </div>
      <div className="chartSection">
        {closedGroupsByCategoryPieChartData.length > 0 ? (
          <PieChartComponent
            title="Por generación"
            data={closedGroupsByCategoryPieChartData}
            pieType="group"
          />
        ) : (
          <div className="graphic">
            <h3>Por generación</h3>
            <div className="chart-empty">
              Grupos cerrados en {selectedCategoryForOpenGroups}: {closedInGeneration}
            </div>
          </div>
        )}
        <PieChartComponent
          title="Por tipo de grupo"
          data={closedGroupsByGroupTypePieChartData}
          pieType="group"
        />
      </div>
    </>
  );
};
